
import axios from "axios";

// Backend URL
// const API_BASE_URL = "http://198.12.253.79:3650/api";
const API_BASE_URL = "http://stockapi.elitewebdemo.com/api";
export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: { "Content-Type": "application/json" },
});

// Attach token automatically (if present)
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// ---------------- AUTH API ----------------
export const authAPI = {
   login: async (email, password) => {
  try {
    const { data } = await apiClient.post("/Auth/login", { email, password });
    return { success: true, data };
  } catch (err) {
    let backendError = err.response?.data;

    // If backend returns default .NET error object → extract title
    if (backendError?.title) {
      return { success: false, error: backendError.title };
    }

    return {
      success: false,
      error: backendError?.message || "Invalid email or password"
    };
  }
  },

 register: async (name, email, password) => {
  try {
    const { data } = await apiClient.post("/Auth/register", {
      name,
      email,
      password,
    });

    return { success: true, data };
  } catch (err) {
    return {
      success: false,
      error: err.response?.data?.message || "Registration failed",
    };
  }
},

  logout: async () => true,
};

// ---------------- COMPANY API ----------------

export const companyAPI = {
  // 🔍 Search companies
  searchCompanies: async (query) => {
    if (!query || query.trim().length < 1) return [];

    try {
      const res = await apiClient.get(`/Search/symbol/${query}`);
      const results = res?.data?.search_results || [];

      return results.map((r) => ({
        name: r.name,
        symbol: r.trading_symbol || "",
      }));
    } catch (err) {
     console.log("MESSAGE:", err.message);
      console.log("STATUS:", err.response?.status);
      console.log("DATA:", err.response?.data);
      return [];
    }
  },

  // 📄 Get details for a company
  getCompanyDetails: async (symbol) => {
    if (!symbol) return null;

    try {
      const { data } = await apiClient.get(`/Search/stock/${symbol}`);
      return data;
    } catch (err) {
  const status = err.response?.status;

  let customError = "Unable to load company details";
let statusCode = status;

if (status === 404) {
  customError = "Company not found";
} else if (status === 429) {
  customError = "Too many requests. Please try again later";
} else if (status === 503) {
  customError = "Service temporarily unavailable";
}

const error = new Error(customError);
error.status = statusCode; // ✅ preserve status

throw error;
    }
  },
 getHistorical: async (symbol) => {
  try {
    const { data } = await apiClient.get(`/Search/historicals/${symbol}`);
    return data;
  } catch (err) {
    console.log("Historical API error:", err.response?.data);
    return [];
  }
},


  // getPeers: async (symbol) => {
  // if (!symbol) return [];

  // try {
  //   const { data } = await apiClient.get(`/Search/peers/${symbol}`);
  //   return data?.peers || [];   // depends on your API response
  // } catch (err) {
  //   console.error("Peers API error:", err);
  //   return [];
  // }
// },

};





